import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Loader2, GraduationCap } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function UniversityLogin() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await fetch(`${API}/universities/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (res.ok) {
        localStorage.setItem('collabhive_uni_token', data.access_token);
        localStorage.setItem('collabhive_uni_name', data.name);
        toast.success('Welcome back');
        navigate('/university/dashboard');
      } else {
        toast.error(data.detail || 'Login failed');
      }
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-primary/5 to-background">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="w-12 h-12 rounded-lg bg-primary/10 text-primary mx-auto flex items-center justify-center mb-2">
            <GraduationCap className="w-6 h-6" />
          </div>
          <CardTitle>University Admin Login</CardTitle>
          <CardDescription>Access your institution's dashboard</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Admin Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="uni-login-email" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="uni-login-password" />
            </div>
            <Button type="submit" disabled={submitting} className="w-full gap-2" data-testid="uni-login-submit">
              {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
              Log In
            </Button>
            <p className="text-center text-xs text-muted-foreground">
              Not registered? <Link to="/university-register" className="text-primary hover:underline">Register your university</Link>
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
